import React from 'react'
import ShadowBox from 'components/ShadowBox'
import Icon from 'components/Icon'
import { observer } from 'mobx-react'
import Link from 'components/Link'
import cx from 'classnames'
import links from 'misc/links'
import './styles.sass'

@observer
export default class GettingStarted extends React.Component {
  render () {
    const { store } = this.props
    return (
      <div className="getting-started">
        <ShadowBox level={2}>
          <div className="getting-started__header">
            <h2 className="getting-started__header-title">Get started with Taxfyle</h2>
            <Progress max={store.progressMax} value={store.progress} />
          </div>
          <div className="getting-started__steps">
            <Step number={1} title="Create account" subtitle={store.accountEmail} completed />
            <Step number={2} title="Get your quote" subtitle="Answer a few simple questions." completed={store.hasAnsweredQuestions} />
            <Step number={3} title="Submit your job order" subtitle="You'll get connected via Live Chat to a Pro specializing in your tax position." />
            <Step number={4} title="Your Pro will handle your tax needs" subtitle="We've got you covered from start to finish." />
          </div>
          <div className="getting-started__button-container">
            <Button link={store.job ? links.projectDetails(store.job.id) : links.newProject()}>
              {store.buttonText}
            </Button>
          </div>
        </ShadowBox>
      </div>
    )
  }
}

const Progress = ({ max, value }) => (
  <div className="getting-started-progress">
    <div className="getting-started-progress__progress-bar" style={{ width: `${(value / max) * 100}%` }} />
  </div>
)

const Step = ({ number, title, subtitle, completed }) => {
  return (
    <div className={cx('getting-started-step', completed && 'getting-started-step--completed')}>
      <div className="getting-started-step__number-container">
        <div className="getting-started-step__number">
          {number}
        </div>
      </div>
      <div className="getting-started-step__text">
        <p className="getting-started-step__title">{title}</p>
        <p className="getting-started-step__subtitle">{subtitle}</p>
      </div>
      <div className="getting-started-step__status-container">
        {completed &&
          <div className="getting-started-step__status">
            <Icon material medium name="check" />
          </div>
        }
      </div>
    </div>
  )
}

const Button = ({ link, children }) => (
  <Link className="button is-awesome has-chevron-right getting-started-button" to={link}>
    {children}
  </Link>
)



// WEBPACK FOOTER //
// ./src/client/screens/Projects/GettingStarted/index.jsx